// Collapsing header on scroll
const $ = jQuery;
const $body = $('body');
const $window = $(window);

// Header mechanics.
const setHeaderCollapsed = function () {
  if ($window.scrollTop() > 30) {
    $body.addClass('om-header-collapsed');
  } else {
    $body.removeClass('om-header-collapsed');
  }
};

setHeaderCollapsed();

$window.scroll(setHeaderCollapsed);

// Add .om-header-mirror-padding to .om-main if no
// other wrappers implement it
if ($('.om-header-mirror-padding').length === 0) {
  $('.om-main').addClass('om-header-mirror-padding');
}

// Configuring header by page content
const $controller = $('[data-header-bg]').first();
const bg = $controller.length ? $controller.data('header-bg') : 'normal';

// bg = normal | transparent | body
$body.addClass(`om-header-bg-${bg}`);

// Apply normal transition property once visible
setTimeout(function () {
  $body.addClass('om-header-bg-done');
}, 300);
